/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-12-01 16:55:37
 */

import React from 'react'
import sensors from '../../utils/sensors'
import { themeColors } from './lib'

interface ThemeColorProps {
  curColor: string
  onChange: (color: string) => void
}

const ThemeColor = ({ curColor, onChange }: ThemeColorProps) => {
  const onClick = (color: string) => {
    sensors.track('web_workgroup_jigsaw_click', {
      clickItem: 'theme_color',
      color: themeColors.find((item) => item.color === color)?.name
    })
    onChange(color)
  }

  return (
    <div className="theme-color">
      {themeColors.map((item, index) => {
        return (
          <div
            className="color"
            key={index}
            onClick={() => onClick(item.color)}
            style={{
              borderColor: curColor === item.color ? '#0093ff' : ''
            }}
          >
            <div
              className="color-item"
              style={{ backgroundColor: item.color }}
            ></div>
          </div>
        )
      })}
    </div>
  )
}

export default ThemeColor
